import { render, staticRenderFns } from "./ShopType.vue?vue&type=template&id=0d9b4bd0&scoped=true"
import script from "./ShopType.vue?vue&type=script&lang=js"
export * from "./ShopType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b4bd0",
  null
  
)

export default component.exports